import React from "react";
import "./Hero.css";
import {
  FaGithubAlt,
  FaLinkedinIn,
  FaDribbble,
  FaFacebook,
} from "react-icons/fa";

export default function Hero() {
  return (
    <div className="hero__wrap">
      <div className="hero__name">Karlo Sayosa</div>
      <div className="hero__title">Web Developer</div>

      <div className="hero-social">
        <a href="https://github.com/kjs17" target="_blank">
          <FaGithubAlt className="hero-git" />
        </a>

        <a href="https://www.linkedin.com/in/kjs17" target="_blank">
          <FaLinkedinIn className="hero-li" />
        </a>
        <a href="https://www.facebook.com/karlo.sayosa" target="_blank">
          <FaFacebook className="hero-fb" />
        </a>
      </div>
      <div className="deploy-demo">
        <a href="#projects">
          <button className="deploy-btn">See Works</button>
        </a>
        <a href="#contact">
          <button className="demo-btn">Get a Demo</button>
        </a>
      </div>
    </div>
  );
}
